import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const DeepCleaningPage = () => {
  const pageData = {
    pageTitle: "Deep Cleaning Cardiff | One-Off House Deep Cleans | NeatWave",
    metaDescription: "Deep cleaning in Cardiff, Barry and Penarth for homes that need extra care. Spring cleans, move-in cleans and intensive kitchen and bathroom cleaning from £90. Request a free quote.",
    quoteService: "Deep Cleaning",
    heroImageAlt: "NeatWave cleaner deep cleaning a kitchen in Cardiff",
    
    heroTitle: "Deep Cleaning Services in Cardiff",
    heroSubtitle: "Comprehensive deep cleaning that reaches every corner. Perfect for spring cleans, moving in, or giving your home the intensive care it deserves.",
    heroImage: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzU5MDg5NzR8MA&ixlib=rb-4.1.0&q=85",
    
    serviceDescription: (
      <>
        <p className="mb-4">
          Our professional deep cleaning service in Cardiff goes far beyond regular cleaning. We tackle built-up dirt, grime, and those hard-to-reach areas that regular cleaning misses. Perfect for spring cleaning, pre-event preparation, or homes that need intensive care.
        </p>
        <p className="mb-4">
          Deep cleaning is recommended at least twice a year or when moving into a new property. Our experienced cleaners use professional-grade equipment and eco-friendly products to achieve outstanding results throughout Cardiff, Barry and Penarth.
        </p>
        <p className="mb-4">
          Every deep clean is tailored to your property's needs. We focus on areas that accumulate dirt over time - behind appliances, inside cabinets, window tracks, skirting boards, and more. All our cleaners are DBS-checked and fully insured.
        </p>
      </>
    ),
    
    whatIncluded: [
      {
        title: "Kitchen Deep Clean",
        description: "Inside appliances, behind fridge/oven, inside cupboards, deep clean of all surfaces, descale taps"
      },
      {
        title: "Bathroom Intensive Clean",
        description: "Deep scrub tiles & grout, descale showerheads, thorough toilet clean, inside cabinets"
      },
      {
        title: "Living Areas Detail",
        description: "Dust high & low surfaces, clean light fixtures, window sills, radiators, skirting boards"
      },
      {
        title: "Bedroom Thoroughness",
        description: "Inside wardrobes, under beds, behind furniture where accessible, all surfaces"
      },
      {
        title: "Windows & Frames",
        description: "Interior window cleaning, frames, tracks, sills, glass doors"
      },
      {
        title: "Hard-to-Reach Areas",
        description: "Behind appliances (where safe), tops of wardrobes, door frames, switches"
      }
    ],
    
    pricingInfo: {
      duration: "3-8 hours",
      price: "From £90",
      note: "Pricing depends on property size and condition. 1-bed from £90, 2-bed from £110, 3-bed from £140. Additional time may be required for neglected properties. Free quote provided."
    },
    
    faqs: [
      {
        q: "How much does a deep clean cost in Cardiff?",
        a: "Deep cleaning starts from £90 for a 1-bed property, £110 for a 2-bed and £140 for a 3-bed. Heavily soiled properties may need extra time. Use our calculator for an instant estimate."
      },
      {
        q: "What's the difference between deep cleaning and regular cleaning?",
        a: "Regular cleaning maintains cleanliness with weekly/fortnightly surface cleaning. Deep cleaning is intensive - we clean inside appliances, behind furniture, descale fixtures, clean inside cupboards, scrub grout, and tackle areas regular cleaning doesn't reach. It's recommended 1-2 times per year."
      },
      {
        q: "How often should I have a deep clean?",
        a: "We recommend deep cleaning at least twice a year - typically spring and autumn. However, you might want more frequent deep cleans if you have pets, allergies, or high foot traffic. Many clients combine regular cleaning with a quarterly deep clean."
      },
      {
        q: "Do I need to move furniture?",
        a: "No, our cleaners will move light furniture where safe and necessary. However, we can't move heavy items like beds, wardrobes, or sofas. If you want these areas cleaned, please arrange to have them moved beforehand."
      },
      {
        q: "Can you focus on specific areas?",
        a: "Absolutely! If you want extra attention on specific rooms (like the kitchen or bathrooms), just let us know when booking. We'll customize the deep clean to focus on your priorities while ensuring the whole property is thoroughly cleaned."
      }
    ],
    
    testimonial: {
      text: "I booked a move-in deep clean. The house had a lot of dirt and grime built up from over the years. Jefferson from Neatwave did a fantastic job of cleaning it and left the place spotless. Very happy with the service. Thank you!",
      author: "Ash Heath, Google review"
    },
    
    relatedServices: [
      {
        title: "Regular Domestic Cleaning",
        description: "Maintain cleanliness with weekly or fortnightly service",
        url: "/domestic-cleaning-cardiff"
      },
      {
        title: "End of Tenancy Cleaning",
        description: "Moving out? Cleaning to landlord and letting agent checklists",
        url: "/end-of-tenancy-cleaning-cardiff"
      },
      {
        title: "Oven Cleaning",
        description: "Specialist oven deep clean service",
        url: "/oven-cleaning-cardiff"
      }
    ]
  };

  return <ServicePageTemplate {...pageData} />;
};

export default DeepCleaningPage;